import { useState } from 'react';
import classNames from 'classnames/bind';
import { FiArrowUpRight } from 'react-icons/fi';

import styles from './index.module.scss';
import LinkButton from '../../../components/linkButton';
import Modal from './Modal';

const cx = classNames.bind(styles);

const BasicInfo = ({ data }) => {
  const [isShowModal, setShowModal] = useState(false);

  const showModal = () => {
    setShowModal(true);
  };

  return (
    <>
      <section className={cx(['container', data.color])}>
        <div className={cx('wrapper')}>
          <p className={cx(['line', 'color'])}>LEVRAI {data.line}</p>
          <h2 className={cx(['name', 'color'])}>
            {data.name} <span>{data.weight}g</span>
          </h2>
          {data.name === 'BLEU' && (
            <p className={cx('desc')}>
              프랑스어 물(L&apos;EAU) 이라는 단어에서 탄생한 <span className={cx('color')}>로로밤 블루</span>는<br />
              건조한 피부에 부드럽게 녹아들어 깊은 보습감을 선사해주는 <span className={cx('color')}>보습 스틱밤</span>입니다.
            </p>
          )}
          {data.name === 'VERT' && (
            <p className={cx('desc')}>
              프랑스어 물(L&apos;EAU) 이라는 단어에서 탄생한 <span className={cx('color')}>로로밤 베르</span>는<br />
              자극받은 피부를 편안하게 케어해주는 매트한 마무리감의 <span className={cx('color')}>진정 스틱밤</span>입니다.
            </p>
          )}
          {data.name === 'ROUGE' && (
            <p className={cx('desc')}>
              프랑스어 칼라(COULEUR)를 뜻하는 단어에서 탄생한 <span className={cx('color')}>코코밤 루즈</span>는<br />
              촉촉하게 은은한 컬러감으로 생기를 불어넣어주는 <span className={cx('color')}>립&amp;치크용 스틱밤</span>입니다.
            </p>
          )}
          {data.name === 'ROSE' && (
            <p className={cx('desc')}>
              프랑스어 칼라(COULEUR)를 뜻하는 단어에서 탄생한 <span className={cx('color')}>코코밤 로즈</span>는<br />
              촉촉하게 은은한 컬러감으로 생기를 불어넣어주는 <span className={cx('color')}>립&amp;치크용 스틱밤</span>입니다.
            </p>
          )}
          <ul className={cx('list')}>
            {data.points.map((point, index) => (
              <li key={point.kr}>
                <p className={cx('point')}>
                  <strong>POINT {index + 1}.</strong>
                  <span className={cx('color')}>{point.kr}</span>
                  {point.en}
                </p>
              </li>
            ))}
          </ul>
          <div className={cx('buttons')}>
            <LinkButton title="SHOP NOW" link={data.url} hoverStyle="black" />
            <button type="button" className={cx(['faq', 'color'])} onClick={showModal}>
              FAQ <FiArrowUpRight />
            </button>
          </div>
        </div>
        <div className={cx('bottom')}>
          <ul className={cx(['listBox', 'softColor'])}>
            <li>FRANCE EVE VEGAN</li>
            <li>DERMATOLOGICALLY TESTED</li>
          </ul>
          <p className={cx('note')}>르브레 스틱밤은 프랑스 비건 인증 제품으로 식물성 원료를 넣어 안심하고 사용할 수 있습니다.</p>
        </div>
      </section>
      {isShowModal && <Modal setShowModal={setShowModal} />}
    </>
  );
};

export default BasicInfo;
